import {AiOutlineInstagram, AiOutlineLinkedin} from 'react-icons/ai'
import {AiOutlineDribbble} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'

export const links = [
    {id: 1, link: '#', title: 'Home'},
    {id: 2, link: '#about', title: 'About'},
    {id: 3, link: '#services', title: 'Services'},
    {id: 4, link: '#portfolio', title: 'Portfolio'},
    {id: 5, link: '#contact', title: 'Contact'}
]


export const socials = [
    {id: 1, link: 'https://www.instagram.com/mouin_boubakri/', icon: <AiOutlineInstagram/>},
    {id: 2, link: 'https://www.linkedin.com/in/mohamed-mouin-boubakri-b47a55255/', icon: <AiOutlineLinkedin/>},
    {id: 3, link: 'https://dribbble.com/M0uin', icon: <AiOutlineDribbble/>},
    {id: 4, link: 'https://github.com/Mouin-bkr', icon: <AiFillGithub/>}
]